<h2 mat-dialog-title>{{ servicio.nombre }}</h2>
<mat-dialog-content class="mat-typography">
    <div class="d-flex flex-column mb-4">
        <span class="fw-500">Estado:</span>
        <mat-chip class="align-self-start" [ngClass]="getChipColorClass(servicio.estado)">
            <mat-icon matChipAvatar>
                {{ getStatusIcon(servicio.estado) }}
            </mat-icon>
            {{ servicio.estado }}
        </mat-chip>
    </div>
    <div class="d-flex flex-column mb-3">
        <span class="fw-500">Detalles:</span>
        <p>{{ servicio.mensaje || 'No hay detalles disponibles para este servicio.' }}</p>
    </div>
    <div class="d-flex flex-column">
        <span class="fw-500">Última actualización:</span>
        {{ servicio.fecha | date: 'dd-MM-yyyy HH:mm' }}
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="custom-button-basic" mat-dialog-close tabindex="-1">Cerrar</button>
</mat-dialog-actions>